import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  memo,
} from "react";
import { Navigate } from "react-router-dom";
import { ShowToast, Severty } from "../helper/toast";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import axios from "axios";
export const AuthContext = createContext();

export const AuthProvider = memo(({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [session, setSession] = useState({ token: null });

  const [userProfile, setUserProfile] = useState();
  const [userPermission, setUserPermission] = useState();
  const [loggingOut, setLoggingOut] = useState(false);

  const fetchUser = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(apiPath.baseURL + `${apiPath.profile}`, {
        headers,
      });
      console.log("User response ====>", response.data.data);
      setUserProfile(response.data.data);
      setUserPermission(response.data.data.permissions);
    } catch (error) {
      // logout()
      console.log(error);
    }
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) return;

    let user = JSON.parse(localStorage.getItem("userProfile"));
    console.log("localStorage User===>", user);
    if (user) {
      fetchUser();
      setUserProfile(user);
    }
    setIsLoggedIn(true);
    setSession({ token: token });
  }, []);

  useEffect(() => {
    if (!userProfile) return;
    localStorage.setItem("userProfile", JSON.stringify(userProfile));
  }, [userProfile]);

  useEffect(() => {
    if (!isLoggedIn) return;
  }, [isLoggedIn]);

  const login = () => {
    setIsLoggedIn(true);
    return <Navigate to="/admin/dashboard" />;
  };

  const logout = async () => {
    /* const headers = {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, 
            'Content-Type': 'application/json', 
        };

        const response  = await axios.get(apiPath.baseURL+`${apiPath.logout}`, { headers }) */
    if (localStorage.getItem("token") != null) {
      localStorage.removeItem("token");
      localStorage.removeItem("userProfile");
      setIsLoggedIn(false);
      setSession({ token: null });
      setUserProfile();
      setLoggingOut(true);
      ShowToast("Logout Successfully", Severty.SUCCESS);
      return <Navigate to="/login" />;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        session,
        setSession,
        userProfile,
        setUserPermission,
        userPermission,
        setUserProfile,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
});

export const useAuthContext = () => {
  return useContext(AuthContext);
};
